import { Group, Modal, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Button } from "src/components/shared/Button/Button";
import { usePostApi } from "src/hooks";
import { useDispatch } from "src/redux/hooks";
import { useSelector } from "src/redux/hooks";
import { setOpenedRefetchModal } from "src/redux/slices/entrySlice";

interface Props {
  refetch: () => void;
}

const RefetchModal = ({ refetch }: Props) => {
  const [opened, { open, close }] = useDisclosure(false);
  const dispatch = useDispatch();
  const { post } = usePostApi();
  const { editing, changed, you } = useSelector(state => state.entrySlice);
  const { logbookId, lbeidOrPartId } = useParams();

  useEffect(() => {
    if (changed && !you) {
      open();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps kept as they were; changing them changes when this runs
  }, [editing, changed, open]);

  useEffect(() => {
    dispatch(setOpenedRefetchModal(opened));
  }, [dispatch, opened]);

  const handleSubmit = async () => {
    await post({
      request: "acknowledge-latest-changes",
      body: {
        params: {
          lbid: logbookId,
          rid: lbeidOrPartId,
        },
      },
    });
    refetch();
    close();
  };

  return (
    <Modal
      opened={opened}
      zIndex={11}
      onClose={handleSubmit}
      withCloseButton={false}
      centered>
      <Text ta="center">
        Another user has edited this entry! It will be automatically updated now
        to ensure you have the most up to date version.
      </Text>
      <Group mt="lg">
        <Button mx="auto" onClick={handleSubmit}>
          OK
        </Button>
      </Group>
    </Modal>
  );
};

export default RefetchModal;
